define('lq/events/actions/readOutlookMessage',[
    'underscore',
    'globalize',
    'lq/events/actions/eventAction',
    'lq/constants'
], function(_, globalize, EventAction, constants) {
    'use strict';

    // reference: https://dev.office.com/reference/add-ins/outlook/1.5/Office

    var initialized = false;
    var afterInitialization = [];
    
    function ReadOutlookMessage(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(ReadOutlookMessage, EventAction);

    ReadOutlookMessage.typeName = 'ReadOutlookMessage';

    // unable to batch for now, because requesting a token is async
    ReadOutlookMessage.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };
    
    ReadOutlookMessage.prototype.execute = function (continuation, eventActionResponse) {
        if (initialized)
            this.startReadingMessage(continuation);
        else {
            afterInitialization.push(this.startReadingMessage.bind(this, continuation));

            require([
                'https://appsforoffice.microsoft.com/lib/1/hosted/Office.js'
            ], function () {
                Office.initialize = function () {
                    initialized = true;

                    _.each(afterInitialization,
                        function (afterInitialization) {
                            afterInitialization();
                        });
                };
            });
        }
    };

    ReadOutlookMessage.prototype.startReadingMessage = function(continuation) {
        if (this.eventData.storeMessage) {
            var self = this;
            Office.context.mailbox.getCallbackTokenAsync(function (callbackToken) {
                if (callbackToken.status !== 'succeeded')
                    throw new Error('Unable to get a token from Outlook.');

                self.piping.dispatcher.dispatch('Outlook/FetchMessage',
                        {
                            actionId: self.piping.actionId,
                            commandId: self.eventData.commandId,
                            ewsUrl: Office.context.mailbox.ewsUrl,
                            callbackToken: callbackToken.value,
                            itemId: Office.context.mailbox.item.itemId
                        })
                    .then(function (result) {
                        if (self.eventData.messageEntityId)
                            self.piping.parameters.locals.setValue(self.eventData.messageEntityId, result.id);

                        self.readParameters(continuation);
                    });
            });
        } else {
            this.readParameters(continuation);
        }
    };

    ReadOutlookMessage.prototype.readParameters = function (continuation) {
        var item = Office.context.mailbox.item;

        if (this.eventData.subject)
            this.piping.parameters.locals.setValue(this.eventData.subject, item.subject);

        if (this.eventData.sender)
            this.piping.parameters.locals.setValue(this.eventData.sender, this.printEmailAddress(item.sender));

        if (this.eventData.to)
            this.piping.parameters.locals.setValue(this.eventData.to, this.printEmailAddresses(item.to));

        if (this.eventData.cc)
            this.piping.parameters.locals.setValue(this.eventData.cc, this.printEmailAddresses(item.cc));

        if (this.eventData.bcc)
            this.piping.parameters.locals.setValue(this.eventData.bcc, this.printEmailAddresses(item.bcc));

        if (this.eventData.hasAttachments)
            this.piping.parameters.locals.setValue(this.eventData.hasAttachments, item.attachments.length > 0);

        if (this.eventData.dateTimeCreated) {
            var theDate = globalize.format(item.dateTimeCreated, constants.licquidDateFormat);
            this.piping.parameters.locals.setValue(this.eventData.dateTimeCreated, theDate);
        }

        if (this.eventData.body) {
            var self = this;
            item.body.getAsync('text', function callback(result) {
                if (result.status !== 'succeeded')
                    throw new Error('Unable to get the body of the mail from Outlook.');

                self.piping.parameters.locals.setValue(self.eventData.body, result.value);
                continuation();
            });
        } else {
            continuation();
        }
    };

    ReadOutlookMessage.prototype.printEmailAddresses = function (addresses) {
        var printedAddresses = _.map(addresses, this.printEmailAddress.bind(this));
        return printedAddresses.join(', ');
    };

    ReadOutlookMessage.prototype.printEmailAddress = function (address) {
        if (!address) return null;

        if (this.eventData.displayMode === 'emailAddress')
            return address.emailAddress;

        if (this.eventData.displayMode === 'displayName')
            return address.displayName;

        return address.displayName + ' <' + address.emailAddress  + '>';
    };

    return ReadOutlookMessage;
});
